<template>
  <!-- Swiper -->
  <div class="swiper mySwipers swiper-no-swiping">
    <div class="swiper-wrapper">
      <div class="swiper-slide " v-for="(item,index) in dataList" :key="index">
        <div :style="{ backgroundImage: `url(${$urlFile+item.bannerImg})` }"
             class="img animate__animated animate__backInRight animate__delay-1s">
        </div>
      </div>

    </div>
    <div style="height: 100%;width: 100%;position: absolute;top:0px;z-index: 999;">
      <div class="subdivtitle" v-if="windowWidth>800">
        <img class="animate__animated animate__zoomIn animate__delay-1s" src="@/assets/home/home_banner2.png"
             height="100%">
        <!--          <img class="animate__animated animate__zoomIn animate__delay-1s" src="@/assets/home/title(1).png"  height="100%" v-if="$i18n.locale == 'en'">-->
        <!--          <img class="animate__animated animate__backInRight animate__delay-1s" src="@/assets/home/title(2).png"  height="100%"  v-if="$i18n.locale == 'en'">-->
      </div>
      <div class="subdivtitle2" v-if="windowWidth<800">
        <img class="animate__animated animate__zoomIn animate__delay-1s" src="@/assets/home/home_banner2.png"
             width="80%" height="auto" v-if="$i18n.locale == 'zh'"
             style="display: flex;align-items: center;margin: 0 auto;">
        <img class="animate__animated animate__zoomIn animate__delay-1s" src="@/assets/home/title(1).png" width="10%"
             height="auto" v-if="$i18n.locale == 'en'" style="align-items: center;">
        <img class="animate__animated animate__backInRight animate__delay-1s" src="@/assets/home/title(2).png"
             width="60%" height="auto" v-if="$i18n.locale == 'en'" style="align-items: center;">
      </div>
      <div class="subdivweather animate__animated animate__fadeInLeftBig animate__delay-2s" v-if="windowWidth>800">
        <el-row>
          <div v-if="this.$i18n.locale=='zh'" style="display: flex;font-size: 2.5vh;align-items: center;">
            <img :src="weatherImageUrl" width="50vh" height="50vh"/>
            <div style="width: 2px;background-color: #76b4f4;height: 7vh;margin: 0 20px 0 20px"></div>
            <div style="padding-right: 0.6vh;color: #fffefe">昆明</div>
<!--            <div style="padding:0 0.5vh;">{{ weatherData.now.text }}</div>-->
            <div style="padding:0 0.9vh;color: #fffefe;">{{ weatherData.now.temp }} ℃</div>
          </div>
          <div v-if="this.$i18n.locale=='en'" style="display: flex;font-size: 2.5vh;align-items: center;">
            <img :src="weatherImageUrl" width="50vh" height="50vh"/>
            <div style="width: 2px;background-color: #76b4f4;height: 7vh;margin: 0 20px 0 20px"></div>
            <div style="padding-right: 0.7vh;font-weight: bold;color: #fffefe">kunming</div>
<!--            <div style="padding:0 0.5vh;">{{ weatherData.now.text }}</div>-->
            <div style="padding:0 0.9vh;color: #fffefe;">{{ weatherData.now.temp }} ℃</div>
          </div>
        </el-row>
        <!--          <iframe width="250" scrolling="no" height="80" frameborder="0" allowtransparency="true"-->
        <!--                  src="https://i.tianqi.com?c=code&id=79&color=%23FFFFFF&icon=1&py=kunming&site=24"></iframe>-->
      </div>
    </div>
  </div>
</template>

<script>
import {getBannerList} from "../../api/banner";
import Swiper from 'swiper'
import {getWeatherData} from "../../api/navtop";

export default {
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      currentIndex: 0,
      dataList: [],
      autoplayInterval: null,
      titleTree: [],
      pid: '',
      classId: 43,
      chgID: 0,
      weatherImageUrl: require('@/assets/img/天气-晴.png'),  //显示天气图标
      weatherData: {
        now: {
          text: '',
          temp: "",
        }
      },
      imgList: [
        {
          url: "1"
        },
        {
          url: "2"
        },
        {
          url: "3"
        },
        {
          url: "4"
        },
      ]
    };
  },
  computed: {
    currentLargeImage() {
      return this.dataList.length > 0 ? this.dataList[this.currentIndex].Img : '';
    },
    currentSmallImage() {
      return this.dataList.length > 0
        ? this.dataList[(this.currentIndex + 1) % this.dataList.length].Img
        : '';
    },
  },
  created() {
    this.titleTree = JSON.parse(sessionStorage.getItem('titleTree'))
    getBannerList({index: 1, size: 10}).then((res) => {
      this.dataList = res.data

    })
    //   getnewList({ classId: 73 }).then((res) => {
    //     res.data.forEach((item) => {
    //       if (item.Img) {
    //         item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
    //         this.dataList.push(item);
    //       }
    //     });
    //     getnewList({ classId: 74 }).then((res) => {
    //     res.data.forEach((item) => {
    //       if (item.Img) {
    //         item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
    //         this.dataList.push(item);
    //       }
    //     });
    //     // // 确保在数据加载完成后启动自动播放
    //     // if (this.dataList.length > 0) {
    //     //   this.startAutoplay();
    //     // }
    //   });

    //   });

  },
  mounted() {
    var swiper = new Swiper(".mySwiper", {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      speed: 2000, // 动画持续时间，单位ms
      //   pagination: {
      //     el: ".swiper-pagination",
      //     dynamicBullets: true,
      //   },
    })
    setTimeout(() => {
      this.init()

    }, 1000);
    // swiper.update()
    this.getWeatherData()

  },
  methods: {
    init() {
      let next = document.getElementById("next")
      let prev = document.getElementById('prev')
      const rotatePic = document.querySelector('.rotate_pic')
      const swiperBox = document.querySelector('.swiper_box')
      const swiperDiv = document.querySelectorAll('.swiper_box div')
      console.log(swiperDiv)
      /*swiperDiv[0].style.transform = `scale(1.2)`
      swiperDiv[0].style.transitionDuration = `1s`*/
      var mySwiper = new Swiper('.mySwipers', {
        // 设置动画效果
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        speed: 2000, // 动画持续时间，单位ms
      });
      mySwiper.update()
      // function render(index) {
      //     for (let i = 0; i < index; i++) {
      //         rotatePic.innerHTML += `<img src="images/rotate_${i + 1}.png">`
      //     }
      // }
      // render(swiperDiv.length)

      this.chgID = 0

      // next.addEventListener('click', () => {
      //     this.chgID++
      //     this.chgID = this.chgID > swiperDiv.length - 1 ? swiperDiv.length - 1 : this.chgID
      //     this.btnCommon()
      // })
      // prev.addEventListener('click', () => {
      //     this.chgID--
      //     this.chgID = this.chgID < 0 ? 0 : this.chgID
      //     this.btnCommon()
      // })

    },
    //初始化获取天气信息
    getWeatherData() {
      getWeatherData().then(res => {
        this.weatherData = res.data.result
        //判断图片文件夹中是否含有该天气对应的图标
        let url = './天气-' + res.result.now.text + '.png'
        let flag = false
        const files = require.context('@/assets/img/', false, /\.png$/)
        const filedata = files.keys()
        // 判断是否有该文件
        filedata.forEach((item) => {
          if (item === url) {
            flag = true
          }
        })
        //若有该天气图标直接放上，否则进行判断
        if (flag) {
          this.weatherImageUrl = require('@/assets/img/天气-' + res.result.now.text + '.png')
        } else if (res.result.now.text == "大暴雨到特大暴雨") {
          this.weatherImageUrl = require('@/assets/img/天气-特大暴雨.png')
        } else if (res.result.now.text == "龙卷风") {
          this.weatherImageUrl = require('@/assets/img/天气-沙尘暴.png')
        } else if (res.result.now.text.indexOf('雪') !== -1) {
          this.weatherImageUrl = require('@/assets/img/天气-雪.png')
        } else if (res.result.now.text.indexOf('雾') !== -1) {
          this.weatherImageUrl = require('@/assets/img/天气-雾.png')
        } else if (res.result.now.text.indexOf('霾') !== -1) {
          this.weatherImageUrl = require('@/assets/img/天气-霾.png')
        } else {
          this.weatherImageUrl = require('@/assets/img/天气-阴.png')
        }
        // if(res.result.now.text == '晴'){
        //   this.weatherImageUrl = require('@/assets/img/天气-晴.png')
        // }else if(res.result.now.text == '多云'){
        //   this.weatherImageUrl = require('@/assets/img/天气-多云.png')
        // }else if(res.result.now.text == '阴'){
        //   this.weatherImageUrl = require('@/assets/img/天气-阴.png')
        // }else if(res.result.now.text == '阵雨'){
        //   this.weatherImageUrl = require('@/assets/img/天气-多云.png')
        // }
      })
    },
    next() {
      const swiperDiv = document.querySelectorAll('.swiper_box div')

      this.chgID++
      // if (this.chgID + 2 == this.imgList.length) {
      //     let obj = JSON.parse(JSON.stringify(this.imgList[0]))
      //     this.imgList.push(obj)
      // }
      // this.chgID = this.chgID > swiperDiv.length - 2 ? swiperDiv.length - 2 : this.chgID
      this.btnCommon()
    },
    prev() {
      const swiperDiv = document.querySelectorAll('.swiper_box div')
      this.chgID--
      // this.chgID = this.chgID < 0 ? 0 : this.chgID
      this.btnCommon()
    },
    btnCommon() {
      const next = document.querySelector('#next')  //后一个按钮
      const prev = document.querySelector('#prev')    //前一个按钮
      const rotatePic = document.querySelector('.rotate_pic')
      const swiperBox = document.querySelector('.swiper_box')
      const swiperDiv = document.querySelectorAll('.swiper_box div')
      // next.style.pointerEvents = this.chgID == swiperDiv.length - 2 ? 'none' : 'auto'   //在划到最后一张或者第一张是否失焦
      // prev.style.pointerEvents = this.chgID == 0 ? 'none' : 'auto'
      // next.style.opacity = this.chgID == swiperDiv.length - 2 ? .6 : 1    //在划到最后一张或者第一张是否透明
      // prev.style.opacity = this.chgID == 0 ? .6 : 1
      // rotatePic.style.transform = `rotate(-${this.chgID * 45}deg)`
      // swiperBox.style.transform = `translateX(-${this.chgID * 100 / swiperDiv.length}%)`
      rotatePic.style.transform = this.chgID > swiperDiv.length - 2 ? `rotate(0deg)` : this.chgID < 0 ? `rotate(-${(swiperDiv.length - 2) * 45}deg)` : `rotate(-${this.chgID * 45}deg)`
      swiperBox.style.transform = this.chgID > swiperDiv.length - 2 ? `translateX(0%)` : this.chgID < 0 ? `translateX(-${(swiperDiv.length - 2) * 100 / swiperDiv.length}%)` : `translateX(-${this.chgID * 100 / swiperDiv.length}%)`
      this.chgID = this.chgID > swiperDiv.length - 2 ? 0 : this.chgID < 0 ? this.chgID = swiperDiv.length - 2 : this.chgID
      for (let i = 0; i < swiperDiv.length; i++) {
        if (i == this.chgID) {
          swiperDiv[i].style.transform = `scale(1.2)`
          swiperDiv[i].style.transitionDuration = `1s`
        } else {
          swiperDiv[i].style.transform = `scale(1)`
          swiperDiv[i].style.transitionDuration = `1s`

        }
      }
    },
    imgClick(obj) {
      this.titleTree.children.forEach((item, index) => {
        // console.log("item",item)
        if (item.children != null) {
          item.children.forEach((item2, index2) => {
            if (item2.data.id === obj.classId) {
              this.pid = item2.data.columnPid
            }
          })
        }
      });
      this.$router.push({
        path: '/detail',
        query: {
          pid: this.pid,
          id: obj.classId,
          detailId: obj.id,
        }
      })
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.dataList.length;
      this.resetAutoplay(); // 重置计时器
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.dataList.length) % this.dataList.length;
      this.resetAutoplay(); // 重置计时器
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        // if((this.chgID+2) == this.dataList.length){
        this.next();
        // }
      }, 3000); // 自动播放间隔，单位毫秒
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    },

  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  //图片点击跳转事件

};
</script>

<style scoped>
html,
body {
  position: relative;
  height: 100%;
}

body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
}

.swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
}

/* .swiper-pagination{
    width: 100%;
  height: 100%;
} */
.subdivtitle:hover {
  transform: translateY(-50%) translateX(-50%) scale(1.1);
}

.subdivtitle {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);;
  left: 50%;
  /* transform: translateX(-50%); */

  /* //background-image: url(../../assets/home/homg_title2.png); */
  width: 100%;
  height: 15vh;
  background-repeat: no-repeat;
  background-position: center; /* 可根据需求调整对齐方式 */
  /* // background-attachment: fixed; */
  background-size: 100% 100%;
  transition: transform 0.3s ease;
  /* // border-radius:30px; */
}

.subdivtitle2:hover {
  transform: translateY(-50%) translateX(-50%) scale(1.1);
}

.subdivtitle2 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);;
  left: 50%;
  /* transform: translateX(-50%); */

  /* //background-image: url(../../assets/home/homg_title2.png); */
  width: 100%;
  /* height: 15vh; */
  background-repeat: no-repeat;
  background-position: center; /* 可根据需求调整对齐方式 */
  /* // background-attachment: fixed; */
  background-size: 100% 100%;
  transition: transform 0.3s ease;
  display: flex;
  justify-content: center;
  /* // border-radius:30px; */
}

.subdivweather {
  right: 5%;
  bottom: 20px;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/swiper_banner.vue